import { render, staticRenderFns } from "./Format.vue?vue&type=template&id=3a23a410&scoped=true"
import script from "./Format.vue?vue&type=script&lang=js"
export * from "./Format.vue?vue&type=script&lang=js"
import style0 from "./Format.vue?vue&type=style&index=0&id=3a23a410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23a410",
  null
  
)

export default component.exports